import React, { ComponentType } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { CrossInCircleIcon, TickInCircleIcon } from '../Icons';
import { TextField } from '../TextField';
import { IFormNumberFieldProps } from './types';

const CustomInput = React.forwardRef(function CustomInput(props: any, ref: React.Ref<unknown>) {
  return <TextField {...props} inputRef={ref} />;
}) as ComponentType<any>;

export const FormNumberField: React.FC<IFormNumberFieldProps> = React.forwardRef(
  (
    {
      defaultValue = '',
      name,
      rules,
      textFieldProps,
      numericFormatProps,
      className = 'w-full',
      shouldShowAdornment = false,
    },
    ref,
  ) => {
    const { control } = useFormContext();

    return (
      <Controller
        defaultValue={defaultValue}
        rules={rules}
        name={name}
        control={control}
        render={props => {
          const isInteracted = props.fieldState.isDirty || props.fieldState.isTouched || props.field.value;
          const isError = Boolean(props.fieldState.error);
          const svgEndAdornment = isInteracted ? isError ? <CrossInCircleIcon /> : <TickInCircleIcon /> : null;

          return (
            <NumericFormat
              className={className}
              value={props.field.value}
              decimalSeparator={'.'}
              customInput={CustomInput}
              type='text'
              error={isError}
              helperText={props.fieldState.error?.message}
              thousandsGroupStyle={'thousand'}
              thousandSeparator={','}
              onValueChange={(values: any) => {
                props.field.onChange(values.floatValue === undefined ? '' : values.floatValue);
              }}
              onBlur={props.field.onBlur}
              getInputRef={props.field.ref || ref}
              {...numericFormatProps}
              {...{
                ...textFieldProps,
                InputProps: {
                  ...textFieldProps?.InputProps,
                  endAdornment: (
                    <>
                      {shouldShowAdornment && svgEndAdornment}
                      {textFieldProps?.InputProps?.endAdornment}
                    </>
                  ),
                },
              }}
            />
          );
        }}
      />
    );
  },
);

FormNumberField.displayName = 'FormNumberField';
